import * as React from "react";
import Result from "./Result";
import {SearchMetaData} from "../services/SearchService";
import {viewType} from "./App";

interface Props {
	results: any[]; // TODO: Type
	meta: SearchMetaData;
	onLoadMore?: onLoadMoreCallback;
	view: viewType;
    offset: number
}

export interface onLoadMoreCallback {
	(): void;
}


export default class ResultsList extends React.Component<Props, any> {


	componentDidMount() {
		this.dispatchEvent();
	}

	handleLoadMore() {
		if (this.props.onLoadMore !== undefined) {
			this.props.onLoadMore();
		}
	}

	componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<any>, snapshot?: any) {
		this.dispatchEvent();
	}


	private dispatchEvent() {

		const event = new CustomEvent('artwork_search_results_loaded', {detail:
				{listResults: this.props.view}
		});

		document.dispatchEvent(event);
	}

	render() {

		const loadMoreButton = (this.props.onLoadMore !== undefined && this.props.meta.hits > this.props.results.length) ? <button type={"button"} className={`load-more`} onClick={() => this.handleLoadMore()}><span className="icon-reload" aria-hidden="true"></span>Mehr anzeigen</button> : null;

		return (
			<div className={"results"}>

                <ul className={`${this.props.view} row g-5`} >
                {this.props.results.map((result, index) => {
                    return (
                        <Result isFirstElement={index=== this.props.offset && this.props.offset > 0} view={this.props.view} key={result.identifier} result={result} />
                    );
                })}
				</ul>

				{loadMoreButton}

			</div>
		);
	}
}
